<template>  
        <TabView  v-model:activeIndex="activeIndex" class="custom-tabview" >
            <TabPanel :header="$t('BAPVA')" >
                <IndexBAPVA v-if="activeIndex === 0"></IndexBAPVA>
            </TabPanel>
            <TabPanel :header="$t('RKTK')">
                <IndexRKTK v-if="activeIndex === 1"></IndexRKTK>
            </TabPanel>
            <TabPanel  :header="$t('ADDENDUM')">
                <IndexAddendum v-if="activeIndex === 2"></IndexAddendum>
            </TabPanel>
        </TabView>
   
</template>
<script>
import IndexBAPVA from './_IndexBAPVA.vue'
import IndexRKTK from './_IndexRKTK.vue'
import IndexAddendum from './_IndexAddendum.vue'
export default{
    name: "AddendumMC",
    components: {
        IndexBAPVA: IndexBAPVA,
        IndexRKTK: IndexRKTK,
        IndexAddendum: IndexAddendum
    },
    data(){
        return{
            activeIndex: 0,
            canViewRKTK : false,
            canViewAddendum : false,
            listTransactionView : [],
        }
    },
    watch: {
        '$route.query.activeIndex': {
            immediate: true,
            handler(newVal) {
                if (newVal !== undefined) {
                    this.activeIndex = parseInt(newVal);
                }
            }
        }
    },
    methods: {
    },
    mounted() {
        this.$emit('unblock-ui');
        // this.listTransactionView =  this.$store.getters.getListTransactionView;
        // this.canViewRKTK = this.listTransactionView.includes('RKTK');
        // this.canViewAddendum = this.listTransactionView.includes('ADDENDUMMC');
         // Set active tab from route query if provided
         if (this.$route.query.activeIndex !== undefined) {
             this.activeIndex = parseInt(this.$route.query.activeIndex);
         }

    }
}
</script>
<style>
.custom-tabview .p-tabview-nav {
  border-bottom: 2px solid #ccc; 
  font-size: 1.2rem; 
  font-weight: 600;
}

.custom-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background-color: #007ad9 !important; 
  color: white !important;
  border-radius: 4px 4px 0 0;
}

.custom-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 0.75rem 1rem;
  border: 1px solid #ccc;
  border-bottom: none;
}

.tab-content-placeholder {
  min-height: 150px; 
  border: 1px solid #ccc;
  border-top: none;
  padding: 1rem;
  background-color: #fafafa;
}
.fixed-table .p-datatable-table {
  table-layout: fixed !important;
  width: 100%;
}
</style>